<template>
  <div class="d-flex h-100" height="100%">
    <v-card class="d-flex flex-column h-100 flex-grow-1 justify-start" elevation="0" outlined v-if="!loading && game" min-height="350" height="100%">
      <v-card-title>
        <v-icon color="secondary" large class="mr-2">track_changes</v-icon>
        <div class="d-flex flex-column">
          <span
            class="primary--text monospace-font body-1 font-weight-medium"
          >{{$t("dashboards.nextGame")}}</span>
          <span
            class="subheader-font body-2 text-ellipsis"
            style="max-width:205px"
          >{{game.leagueName}} - {{game.matchDate}}</span>
        </div>
      </v-card-title>
      <div class="d-flex align-center justify-center mb-2">
        <div class=" d-flex justify-end align-center mr-2 w-36">
          <div>
            <v-img
              :src="game.homeTeamImgError ? 'https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/0.png' : 'https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/' + game.homeTeamId + '.png'"
              :height="20"
              :width="20"
              class="mx-1"
              v-on:error="onImgError($event,'home')"
            />
          </div>
          <router-link
            :to="`/team/${game.homeTeamId}`"
            class="font-weight-medium body-2 text-ellipsis"
          >{{game.homeTeamName}}</router-link>
        </div>
        <span :to="`/game/${game.gameId}`" class=" d-flex text-h6 font-weight-bold text-center black--text">
          <span class="mx-1">-</span>
        </span>
        <div class="ml-2 d-flex align-center w-36">
          <router-link
            :to="`/team/${game.awayTeamId}`"
            class="font-weight-medium body-2 text-ellipsis"
          >{{game.awayTeamName}}</router-link>
          <div>
            <v-img
              :src="game.awayTeamImgError ? 'https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/0.png' : 'https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/' + game.awayTeamId + '.png'"
              :height="20"
              :width="20"
              class="mx-1"
              v-on:error="onImgError($event,'away')"
            />
          </div>
        </div>
      </div>
      <v-divider class="my-1"></v-divider>
      <div class="d-flex align-center justify-center py-1">
        <span class="primary--text w-12 text-center" v-if="homeStats">{{homeStats.possession.toFixed(1)}}%</span>
        <v-chip outlined small :color="$vuetify.theme.dark ? 'primary lighten-4' : 'primary'" class="body-2">{{$t('game.stats.averagePossession')}} </v-chip>
        <span class="primary--text w-12 text-center" v-if="awayStats">{{awayStats.possession.toFixed(1)}}%</span>
      </div>
      <v-divider class="my-1"></v-divider>
      <div class="d-flex align-center justify-center py-1">
        <span class="primary--text w-10 text-center" v-if="homeStats">{{homeStats.shotsPerGame.toFixed(1)}}</span>
        <v-chip outlined small :color="$vuetify.theme.dark ? 'primary lighten-4' : 'primary'" class="body-2">{{$t('game.stats.averageShots')}} </v-chip>
        <span class="primary--text w-10 text-center" v-if="awayStats">{{awayStats.shotsPerGame.toFixed(1)}}</span>
      </div>
      <v-divider class="my-1"></v-divider>
      <div class="d-flex align-center justify-center py-1">
        <span class="primary--text w-10 text-center" v-if="homeStats">{{homeStats.shotsOnTargetPerGame.toFixed(1)}}</span>
        <v-chip outlined small :color="$vuetify.theme.dark ? 'primary lighten-4' : 'primary'" class="body-2">{{$t('playerRecruitment.average')}} {{$t('game.stats.shotsOnTarget')}} </v-chip>
        <span class="primary--text w-10 text-center" v-if="awayStats">{{awayStats.shotsOnTargetPerGame.toFixed(1)}}</span>
      </div>
      <v-divider class="my-1"></v-divider>
      <div class="d-flex align-center justify-center py-1">
        <span class="primary--text w-10 text-center" v-if="homeStats">{{homeStats.xGPerGame.toFixed(1)}}</span>
        <v-chip outlined small :color="$vuetify.theme.dark ? 'primary lighten-4' : 'primary'" class="body-2">{{$t('game.stats.averagexG')}} </v-chip>
        <span class="primary--text w-10 text-center" v-if="awayStats">{{awayStats.xGPerGame.toFixed(1)}}</span>
      </div>
      <v-divider class="my-1"></v-divider>
      <div class="d-flex align-center justify-center py-1">
        <span class="primary--text w-10 text-center" v-if="homeStats">{{homeStats.ppdaPerGame.toFixed(1)}}</span>
        <v-chip outlined small :color="$vuetify.theme.dark ? 'primary lighten-4' : 'primary'" class="body-2">{{$t('playerRecruitment.average')}} {{$t('game.stats.ppda')}} </v-chip>
        <span class="primary--text w-10 text-center" v-if="awayStats">{{awayStats.ppdaPerGame.toFixed(1)}}</span>
      </div>
      <v-divider class="my-1"></v-divider>
      <div class="d-flex align-center justify-end px-2 py-2" v-if="userHasRole('ROLE_EVENTING_DATA')">
        <v-btn color="secondary" class="elevation-0 monospace-font white--text px-5" rounded small :to="`/team/${rivalId}/analysis`">{{$t('dashboards.seeRival')}}</v-btn>
      </div>
    </v-card>
    <v-card elevation="0" outlined class="d-flex justify-center align-center py-8 px-12" v-if="loading">
      <v-progress-circular :size="75" color="secondary" indeterminate></v-progress-circular>
    </v-card>
    <v-card elevation="0" outlined v-if="!loading && !game" class="d-flex flex-column flex-grow-1">
      <v-card-title>
        <v-icon color="secondary" large class="mr-2">track_changes</v-icon>
        <div class="d-flex flex-column">
          <span
            class="primary--text monospace-font body-1 font-weight-medium"
          >{{$t("dashboards.nextGame")}}</span>
        </div>
      </v-card-title>
      <div class="d-flex justify-center align-center flex-column px-3 py-4 mb-13 text-center flex-grow-1">
        <v-icon color="primary lighten-5" v-bind:style="{'font-size':$vuetify.breakpoint.mdAndUp ? '80px' : '60px'}">event_busy</v-icon>
        <span class="primary--text lighten--text-2 body-1">{{$t("dashboards.placeholderNextGame")}}</span>
      </div>
    </v-card>
  </div>
</template>

<script>
import GameService from "../../../services/game/game.service";
import TeamService from "../../../services/team/team.service";
import ResizeObserver from 'resize-observer-polyfill';
import { userHasRole } from "../../../utils/functions";

export default {
  name: "NextGameWidget",
  components: {
  },
  props: {
    teamId: {
      type: Number,
      required: true
    },
    seasonId: {
      type: Number,
      required: false
    },
  },
  data() {
    return {
      team: null,
      game: null,
      rivalId: null,
      homeStats: null,
      awayStats: null,
      loading: false,
      observer: null
    };
  },
  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    }
  },
  filters: {
  },
  mounted() {
    this.loadViewData();
    this.observer = new ResizeObserver(this.onResize)
    .observe(this.$el)
  },
  destroyed() {
    delete this.observer;
  },
  methods: {
    onResize () {
      this.$emit('heightChange', this.$el.clientHeight)
    },
    async loadViewData() {
      await this.loadGame();
      if(this.game){
        this.homeStats = await this.loadTeamAvgStats(this.game.homeTeamId, 1);
        this.awayStats = await this.loadTeamAvgStats(this.game.awayTeamId, 2);
      }
    },
    async loadTeam(){
      this.loading = true;
      let teamResponse = await TeamService.getTeamInfo(this.teamId);
      this.team = teamResponse.data;
      this.loading = false;
    },
    async loadGame() {
      this.loading = true;
      let gameResponse = await GameService.getNextGames(this.teamId, 1);
      this.game = gameResponse.data[0];
      if (this.game)
        this.rivalId = this.teamId === this.game.homeTeamId ? this.game.awayTeamId : this.game.homeTeamId;
      this.loading = false;
    },
    async loadTeamAvgStats(teamId,side) {
      let teamResponse = await TeamService.getTeamAvgStats(
        teamId,
        this.seasonId ? this.seasonId : this.game.seasonId
      );
      let stats = _.find(teamResponse.data,(d) => d.groundId === side);
      if(!stats){
        stats = _.find(teamResponse.data,(d) => d.groundId === 3);
      }
      return stats;
    },
    onImgError(event,side){
      if(side === 'home'){
        this.game.homeTeamImgError = true;
      }else if(side === 'away'){
        this.game.awayTeamImgError = true;
      }
    },
    userHasRole(role) {
      return userHasRole(this.currentUser, role);
    },
  }
};
</script>



// WEBPACK FOOTER //
// src/views/dashboard/widgets/NextGameWidget.vue